// Navigation
import {
  GROUPS_OF_PAGES,
  NAV_GROUPS,
  NAV_SUBGROUPS,
  NAV_LINKS,
} from './navigation';

import { PAGES_DATA } from './pages';

export * from './navigation';
export * from './shared-blocks';
export * from './pages';

export default {
  GROUPS_OF_PAGES,
  PAGES_DATA,
  NAV_GROUPS,
  NAV_SUBGROUPS,
  NAV_LINKS,
};
